const dotenv = require('dotenv')
dotenv.config()
module.exports = {
  GOOGLE_MAPS_KEY: process.env.REACT_APP_GOOGLE_MAPS_KEY,
}
